import Swiper, { Autoplay, Navigation, Pagination, EffectFade } from "swiper";

Swiper.use([Autoplay, Navigation, Pagination, EffectFade]);

// TOPページのMV
new Swiper(".p-top-sp-mv", {
  slidesPerView: 1,
  loop: true,
  speed: 1500,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 3500,
  },
});

// TOPページ TOPICS,OFFERS
new Swiper(".p-top-slide__wrap", {
  loop: true,
  slidesPerView: 2,
  spaceBetween: 20,
  // speed: 10000,
  pagination: {
    el: ".p-top-slide__pagenation",
    clickable: true,
  },
  navigation: {
    prevEl: ".p-top-slide__prev",
    nextEl: ".p-top-slide__next",
  },
  autoplay: true,
  breakpoints: {
    769: {
      slidesPerView: 3,
    },
    1023: {
      slidesPerView: 3,
    },
    1260: {
      spaceBetween: 23,
      slidesPerView: 4,
    },
  },
});
new Swiper(".p-top-slide__wrap--offers", {
  loop: false,
  slidesPerView: 2,
  spaceBetween: 20,
  pagination: {
    el: ".p-top-slide__pagenation--offers",
    clickable: true,
  },
  navigation: {
    prevEl: ".p-top-slide__prev--offers",
    nextEl: ".p-top-slide__next--offers",
  },
  autoplay: {
    delay: 3500,
  },
  breakpoints: {
    769: {
      slidesPerView: 3,
    },
    1023: {
      slidesPerView: 3,
    },
    1260: {
      spaceBetween: 23,
      slidesPerView: 4,
    },
  },
});

// TOPページ 旅色バナー
new Swiper(".p-top-slide__wrap--tabiiro", {
  loop: true,
  slidesPerView: 1,
  // spaceBetween: 5,
  // centeredSlides : true,
  // speed: 10000,
  pagination: {
    el: ".p-top-slide__pagenation--tabiiro",
    clickable: true,
  },
  navigation: {
    prevEl: ".p-top-slide__prev--tabiiro",
    nextEl: ".p-top-slide__next--tabiiro",
  },
  autoplay: true,
});

// TOPページ キャンペーンバナー
new Swiper(".p-top-slide__wrap--event", {
  loop: true,
  slidesPerView: 1,
  // spaceBetween: 5,
  // centeredSlides : true,
  // speed: 10000,
  pagination: {
    el: ".p-top-slide__pagenation--event",
    clickable: true,
  },
  navigation: {
    prevEl: ".p-top-slide__prev--event",
    nextEl: ".p-top-slide__next--event",
  },
  autoplay: true,
});

// EXPERIENCE 無限スライド
new Swiper(".p-top-slide__wrap--experience", {
  loop: true,
  slidesPerView: 2,
  spaceBetween: 20,
  speed: 9500,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
  },
  breakpoints: {
    650: {
      slidesPerView: 3,
      spaceBetween: 10,
      speed: 8000,
    },
    769: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    1023: {
      slidesPerView: 5,
      spaceBetween: 10,
    },
    1260: {
      slidesPerView: 5,
    },
  },
});
